import React, { useEffect, useRef, useState } from 'react';
import currentLocation from '../../image/icons/floating/CurrentLocationTr.svg';
import { useLocationContext } from '../../store/LocationContext';
import { useEphemeral } from '../../store/EphemeralContext';
import { isDesktop } from 'react-device-detect';

interface ContainerProps {
  returnToUserLocation: () => void;
}

const GpsFloatingActions: React.FC<ContainerProps> = ({ returnToUserLocation }) => {
  const { userLocation } = useLocationContext();
  const {
    state: { map }
  } = useEphemeral();

  // On démarre l'animation dès le montage du composant.
  const [blink, setBlink] = useState<boolean>(true);
  const [bgColor, setBgColor] = useState<string>('white');
  const startLocation = useRef(userLocation);

  useEffect(() => {
    if (userLocation !== startLocation.current) {
      setBlink((b) => {
        if (b) {
          map?.flyTo({
            center: {
              lat: userLocation.latitude,
              lng: userLocation.longitude
            }
          });
        }
        return false;
      });
    }
  }, [map, userLocation]);

  // Optionnel : redémarrer l'animation lorsque l'onglet redevient visible
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        setBlink(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [userLocation]);

  // Effet qui gère le clignotement de l'arrière-plan
  useEffect(() => {
    if (isDesktop) {
      return;
    }
    if (!blink) {
      setBgColor('white');
      return;
    }

    const interval = setInterval(() => {
      setBgColor((prevColor) => (prevColor === 'white' ? 'red' : 'white'));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, [blink]);

  return (
    <div className="flex">
      <div className="m-2 mb-1 mr-3 ml-auto cursor-pointer" onClick={returnToUserLocation} style={{ backgroundColor: bgColor, borderRadius: '50%' }}>
        <img src={currentLocation} className="w-[40px] shadow-xl rounded-full" alt="Current location" />
      </div>
    </div>
  );
};

export default GpsFloatingActions;
